import { render, staticRenderFns } from "./EditEntity.vue?vue&type=template&id=ca17f978&scoped=true"
import script from "./EditEntity.vue?vue&type=script&lang=ts"
export * from "./EditEntity.vue?vue&type=script&lang=ts"
import style0 from "./EditEntity.vue?vue&type=style&index=0&id=ca17f978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca17f978",
  null
  
)

export default component.exports